import * as React from 'react';
import styled from 'styled-components';
import { Button } from '../Button';
import { MoreVertical } from '../icons';
import { BREAKPOINTS, COLORS } from '../styles';
import { ListRowDropdownOption } from '../types';

import ListRowDropdown from './ListRowDropdown';

const EditRow = styled.div<{ disableDifferentBackgroundforEvenNumbers?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  align-items: center;

  &:nth-child(even) {
    background-color: ${props => (props.disableDifferentBackgroundforEvenNumbers ? 'inherit' : COLORS.neutral_20)};
  }

  .user-actions {
    display: flex;
    position: relative;
    align-items: center;
  }

  .somePaddingForAlignment {
    padding: 0 3px 0 0;
  }

  &.active {
    background-color: ${COLORS.neutral_100};
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  align-items: center;
  svg {
    margin-right: 12px;
  }
`;

const MainInfo = styled.div`
  margin: auto 1em auto 0;
  display: flex;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
  outline: none;
`;

const UserDropdownButton = styled(Button)`
  display: flex;
  text-decoration: none;
  outline: none;
  div {
    outline: none;
  }
  &:focus > div {
    box-shadow: 0px 0px 8px #2e7fa1, 0px 4px 12px rgba(46, 127, 161, 0.25);
    border-radius: 4px;
    outline: none;
    background: ${COLORS.white};
  }
`;

const StyledMoreVertical = styled(MoreVertical)`
  padding: 8px 8px;
  outline: none;
  &:hover {
    background: ${COLORS.primary_20};
    border-radius: 4px;
  }
  &:active {
    background: ${COLORS.primary_100};
    border-radius: 4px;
  }
`;

type Props = {
  key?: string;
  Icon?: any;
  mainInfo: any;
  dropdownOptions: ListRowDropdownOption[];
  disableDifferentBackgroundforEvenNumbers?: boolean;
};

const ListRow: React.FunctionComponent<Props> = ({ key, Icon, mainInfo, dropdownOptions, disableDifferentBackgroundforEvenNumbers }: Props) => {
  const color = COLORS.black;
  const [dropdownActive, setDropdownActive] = React.useState<Boolean>(false);

  return (
    <EditRow key={key} disableDifferentBackgroundforEvenNumbers={disableDifferentBackgroundforEvenNumbers}>
      <LeftSection color={color} data-hj-suppress>
        {Icon && <Icon size="22px" color={color} className="somePaddingForAlignment" />}
        <MainInfo data-hj-suppress>{mainInfo}</MainInfo>
      </LeftSection>

      <ButtonWrapper className="user-actions">
        <UserDropdownButton
          variant="text"
          onClick={() => {
            setDropdownActive(true);
          }}>
          <div tabIndex={-1}>
            <StyledMoreVertical size="22px" color={COLORS.neutral_500} />
          </div>
        </UserDropdownButton>
        {dropdownActive && <ListRowDropdown closeDropdown={() => setDropdownActive(false)} options={dropdownOptions} />}
      </ButtonWrapper>
    </EditRow>
  );
};

export default ListRow;
